module.exports = __webpack_public_path__ + "static/img/login-left.ccdf5ef1.png";